<template>
  <div id="terms">
    <PageHeader />
    <main>
      <div class="container mt-6">
        <h4>Syarat dan Ketentuan</h4>
        <p>Berlaku sejak 20 Desember 2020.</p>
        <ol class="list-content">
          <li>
            PENGANTAR<br />Dengan mendaftar atau menggunakan layanan aplikasi buatan Rasylva, termasuk semua fitur dan
            fungsi, situs web, dan antarmuka pengguna yang terkait, serta semua konten dan aplikasi perangkat lunak yang
            berhubungan dengan layanan kami (secara bersama-sama disebut &ldquo;Layanan Rasylva&rdquo; atau
            &ldquo;Layanan&rdquo;), atau mengakses informasi atau materi lain yang tersedia melalui Layanan
            (&ldquo;Konten&rdquo;), Anda menyetujui syarat dan ketentuan yang berlaku (sebagai
            &ldquo;Perjanjian&rdquo;). Jika Anda tidak menyetujui, silakan menghentikan penggunaan Layanan Rasylva serta
            penggunaan informasi atau aplikasi apapun yang berasal dari entitas Rasylva.
          </li>
          <li>
            MODIFIKASI SITUS WEB DAN KETENTUAN<br />Kami sesekali dapat melakukan perubahan pada Perjanjian ini karena
            alasan yang sah, seperti (1) meningkatkan fungsi atau fitur yang ada atau menambahkan fungsi atau fitur baru
            ke Layanan, (2) menerapkan kemajuan dalam sains dan teknologi, dan penyesuaian teknis yang wajar pada
            Layanan, (3) memastikan pengoperasian keamanan Layanan, dan (4) karena alasan hukum atau peraturan. Saat
            kami melakukan perubahan yang signifikan pada Perjanjian, kami akan memberikan Anda pemberitahuan yang
            sesuai dengan keadaan, misalnya dengan menampilkan pemberitahuan penting atau berusaha mendapatkan
            persetujuan Anda dalam Layanan atau dengan mengirimkan surel kepada Anda. Dalam beberapa hal, kami akan
            memberitahu Anda sebelumnya, dan penggunaan Layanan secara terus-menerus setelah perubahan dilakukan
            merupakan penerimaan Anda atas perubahan tersebut. Oleh karena itu, pastikan Anda membaca pemberitahuan
            tersebut dengan teliti. Apabila Anda tidak ingin lagi menggunakan Layanan berdasarkan versi baru Perjanjian,
            Anda dapat menutup akun Anda dengan menghubungi kami.
          </li>
          <li>
            PEMBERIAN LISENSI<br />Rasylva memberi Anda hak untuk mengakses dan menggunakan seluruh fitur dan Lisensi
            dari Layanan Rasylva. Hak ini non-eksklusif, tidak dapat dipindahtangankan, serta dibatasi oleh dan tunduk
            pada perjanjian ini. Akses ini akan tetap berlaku hingga dan kecuali diakhiri oleh Anda atau Rasylva. Anda
            berjanji dan setuju bahwa Anda menggunakan Layanan Rasylva hanya untuk kepentingan pribadi. Anda tidak
            boleh: (a) memodifikasi, mengadaptasi, men-dekompilasi, membongkar, dan/atau merekayasa komponen apapun dari
            Layanan Rasylva dan Konten; (b) membuat karya turunan berdasarkan komponen apapun dari Layanan Rasylva dan
            Konten; (c) mengizinkan pihak ketiga untuk menggunakan atau mengakses komponen apapun dari Layanan Rasylva
            dan Konten; (d) menerima Lisensi melalui pihak ketiga dalam menggunakan Layanan Rasylva. Anda setuju untuk
            mematuhi Panduan pengguna dan tidak menggunakan Layanan Rasylva dengan cara yang tidak diizinkan secara
            tegas dalam Perjanjian.
          </li>
          <li>
            HAK KEPEMILIKAN DAN HAK CIPTA<br />Anda mengakui dan menyetujui bahwa: (a) Layanan Rasylva adalah milik
            Rasylva dan bukan milik Anda; (b) Anda akan menggunakan Layanan Rasylva hanya dengan syarat dan ketentuan
            yang dijelaskan di Perjanjian ini.
          </li>
          <li>
            KOMUNIKASI ELEKTRONIK<br />Anda sepakat bahwa Rasylva dapat mengirimkan surel kepada Anda dengan tujuan
            memberikan informasi terkait perubahan Situs Web, Ketentuan, ataupun hal-hal lain yang terkait dengan
            Rasylva. Anda dapat memilih untuk tidak dikirimkan surel dengan membalas surel kami.
          </li>
          <li>
            PEMBAYARAN BIAYA LAYANAN<br />Dalam pemberian Lisensi penggunaan Layanan Rasylva, Anda harus melakukan
            pembayaran biaya layanan (&ldquo;Biaya Layanan&rdquo;) kepada Rasylva berdasarkan harga paket yang tertera
            pada situs web Rasylva.id. Harga paket Biaya Layanan dapat berubah sewaktu-waktu tanpa pemberitahuan
            terlebih dahulu. Pengguna yang telah melakukan pembayaran Biaya Layanan pada paket sebelumnya akan tetap
            menggunakan paket tersebut sampai Lisensinya berakhir.
          </li>
          <li>
            PEMBATALAN LISENSI<br />Anda dapat melakukan pembatalan Lisensi dengan cara menghubungi Rasylva melalui
            surel. Pembatalan lisensi hanya dapat dilakukan dalam waktu 1x24 jam setelah melakukan pembayaran Biaya
            Layanan. Anda akan dikenakan Biaya Pembatalan Lisensi sebesar Rp5.000. Pengembalian uang Anda yang telah
            dipotong Biaya Pembatalan akan ditransfer melalui rekening atau dompet elektronik yang Anda berikan melalui
            surel pada saat permintaan pembatalan Lisensi.
          </li>
          <li>
            APLIKASI DAN PERANGKAT PIHAK KETIGA<br />Untuk dapat menggunakan Layanan Rasylva dalam versi lengkap, Anda
            harus melakukan registrasi dengan menggunakan akun Google milik Anda. Dalam proses registrasi tersebut, Anda
            setuju bahwa Rasylva boleh mendapatkan data Anda di akun Google Anda, termasuk nama lengkap, alamat surel,
            foto akun, dan data lainnya sesuai dengan izin Anda pada saat registrasi. Selain itu, Rasylva juga dapat
            mengunggah data Anda yang terdapat di dalam Layanan Rasylva ke layanan Google Drive milik Anda. Rasylva
            menggunakan layanan dari Midtrans untuk proses pembayaran Biaya Layanan, sehingga nominal yang Anda transfer
            akan terlebih dahulu masuk ke akun Rasylva di Midtrans. Pencairan nominal tersebut dapat dilakukan oleh
            Rasylva kapanpun sesuai aturan dari Midtrans.
          </li>
          <li>
            BANTUAN DAN DUKUNGAN<br />Anda dapat menghubungi Rasylva jika terdapat kendala yang terjadi dalam penggunaan
            Aplikasi dan Layanan Rasylva melalui kontak yang tertera pada situs web Rasylva.id.
          </li>
          <li>
            PEMBATALAN PERJANJIAN<br />Rasylva dapat menghentikan atau membatalkan Perjanjian secara langsung jika: (1)
            Anda tidak dapat membayar hutang yang terjadi antara Anda dan Rasylva, atau (2) Anda tidak dapat menjalankan
            kewajiban Anda dalam Perjanjian ini. Pada saat penghentian Perjanjian, segala Lisensi Layanan Rasylva yang
            telah diberikan kepada Anda akan dicabut.
          </li>
          <li>
            HAK PENGGUNA<br />Anda berhak menggunakan Layanan Rasylva dalam versi percobaan dengan batasan-batasan yang
            telah ditentukan pada setiap Layanan tersebut. Anda berhak menggunakan Layanan Rasylva dalam versi lengkap
            setelah Anda melakukan pembayaran Biaya Layanan dan mendapatkan Lisensi dari paket yang Anda pilih. Selain
            hak-hak yang secara khusus diberikan dalam dokumen ini, Anda mempertahankan kepemilikan semua hak, termasuk
            hak kekayaan intelektual.
          </li>
          <li>
            HAK RASYLVA<br />Dengan mempertimbangkan hak yang diberikan kepada Anda berdasarkan Perjanjian ini, Anda
            memberikan hak kepada kami untuk: (a) mengizinkan Layanan Rasylva untuk menggunakan prosesor, bandwidth, dan
            perangkat keras penyimpanan pada Perangkat Anda agar dapat mempermudah pengoperasian Layanan; dan (b)
            memberikan iklan dan informasi lain untuk Anda.<br />Apabila Anda memberikan masukan, gagasan, atau saran
            kepada Rasylva terkait dengan Layanan Rasylva atau Konten (&ldquo;Masukan&rdquo;), Anda mengakui bahwa
            Masukan tersebut tidak bersifat rahasia dan Anda memberikan wewenang kepada Rasylva untuk menggunakan
            Masukan tersebut tanpa batasan dan tanpa pembayaran kepada Anda. Masukan dianggap sebagai jenis Konten
            Pengguna.
          </li>
          <li>
            PENYIMPANAN DATA DAN KEAMANAN<br />Data pengguna dalam Layanan Rasylva akan disimpan dalam perangkat
            pengguna dan tidak disinkronisasi dengan server Rasylva, kecuali data akun Pengguna yang tercantum dalam
            Kebijakan Privasi. Rasylva wajib melakukan pencegahan pembobolan celah keamanan di server Rasylva maupun
            komunikasi antara server dan perangkat pengguna. Jika terjadi pembobolan, perusakan, ataupun hal lain yang
            menyebabkan hilangnya data pengguna di server Rasylva, maka Rasylva akan bertanggung jawab atas hal tersebut
            dengan berusaha untuk mengembalikan data yang hilang. Jika tidak dapat dikembalikan, maka Rasylva wajib
            melakukan ganti rugi terhadap data tersebut dengan sejumlah uang yang dapat didiskusikan nantinya. Rasylva
            tidak bertanggung jawab atas keamanan di dalam perangkat pengguna. Jika kehilangan data terjadi di perangkat
            pengguna, maka Rasylva tidak bertanggung jawab atas hal tersebut.
          </li>
          <li>
            KONTEN DAN PRINSIP METODE ILMIAH<br />Dalam penggunaan Layanan Rasylva, Anda bertanggung jawab secara penuh
            terhadap data yang anda miliki. Layanan Rasylva hanya membantu pengguna dalam melakukan pengambilan dan
            pengolahan data. Jika terdapat data yang dipublikasi oleh pengguna dan tidak sesuai dengan prinsip-prinsip
            metode ilmiah, maka hal tersebut adalah tanggung jawab pengguna. Jika Anda menemukan kesalahan pengolahan
            data yang disebabkan oleh sistem Layanan Rasylva, Anda dapat melaporkannya ke pihak Rasylva agar dapat
            ditindaklanjuti.
          </li>
          <li>HUKUM YANG BERLAKU<br />Ketentuan ini berlaku dan diatur oleh hukum dan undang-undang di Indonesia.</li>
          <li>
            PERTANYAAN, KRITIK, DAN SARAN<br />Kami menerima pertanyaan, kritik, dan saran terkait privasi dan informasi
            apapun yang kami dapatkan dari pengguna. Silakan hubungi kami melalui menu kontak yang tertera pada situs
            web Rasylva.id.
          </li>
        </ol>
      </div>
      <div id="privacy" class="container mt-6">
        <h4 style="padding-top: 80px">Kebijakan Privasi</h4>
        <p>
          Salah satu prioritas utama Rasylva.id adalah privasi pengunjung dan pengguna layanan kami. Dokumen Kebijakan
          Privasi ini berisi jenis informasi yang dikumpulkan dan dicatat oleh Rasylva.id dan bagaimana kami
          menggunakannya.
        </p>
        <p>
          Jika Anda memiliki pertanyaan tambahan atau memerlukan informasi lebih lanjut tentang Kebijakan Privasi kami,
          jangan ragu untuk menghubungi kami.
        </p>
        <ol class="list-content">
          <li>
            INFORMASI YANG KAMI KUMPULKAN<br />
            <ul class="list-content browser-default disc">
              <li>
                File Log<br />
                Rasylva.id mengikuti prosedur standar menggunakan file log. File-file ini mencatat pengunjung ketika
                mereka mengunjungi situs web. Hampir semua perusahaan layanan internet melakukan ini dan merupakan
                bagian dari analisis layanan kami. Informasi yang dikumpulkan oleh file log termasuk alamat protokol
                internet (IP), sistem operasi, jenis browser, Penyedia Layanan Internet (ISP), tanggal dan waktu,
                halaman rujukan/keluar, dan jumlah klik. Ini tidak terkait dengan informasi apa pun yang dapat
                diidentifikasi secara pribadi. Tujuan informasi adalah untuk menganalisis tren, mengelola situs, melacak
                pergerakan pengguna di situs web, mengumpulkan informasi demografis, dan mencegah terjadinya
                penyalahgunaan ataupun tindakan yang membahayakan keamanan server Rasylva.id.
              </li>
              <li>
                Informasi Kontak<br />
                Rasylva.id mendapatkan informasi kontak pengguna seperti nama dan alamat email dari pihak ketiga
                (Google) pada saat pengguna melakukan pendaftaran di layanan kami.
              </li>
              <li>
                Cookies<br />
                Seperti situs web lainnya, Rasylva.id menggunakan "cookie". Cookie digunakan untuk menyimpan informasi
                seperti preferensi pengunjung dan halaman yang diakses atau dikunjungi pengunjung pada situs web
                Rasylva.id. Informasi tersebut kami gunakan untuk mengoptimalkan pengalaman pengguna dengan menyesuaikan
                konten halaman web kami. Anda berhak untuk menonaktifkan cookies pada browser Anda.
              </li>
              <li>
                Konten Layanan: Jenis Tumbuhan<br />
                Rasylva.id menggunakan data jenis tumbuhan yang Anda masukkan ke dalam Aplikasi Rasylva untuk melengkapi
                basis data Rasylva sehingga nantinya dapat memberikan saran pengisian data yang lebih lengkap kepada
                pengguna lain, begitu juga data dari pengguna lain akan menjadi saran pengisian data untuk Anda.
              </li>
            </ul>
          </li>
          <li>
            CARA PENGGUNAAN INFORMASI<br />
            Kami menggunakan informasi pribadi pengguna untuk penggunaan Layanan Rasylva seperti:<br />
            <ul class="list-content browser-default disc">
              <li>Mengupdate informasi layanan atau produk kepada pengguna.</li>
              <li>Keperluan komunikasi proses penawaran/pembelian produk atau layanan.</li>
              <li>Mengirim katalog, promosi, email marketing, newsletter, dan proses digital marketing lainnya.</li>
              <li>Menyimpan konten pengguna seperti data tumbuhan ke Google Drive milik pengguna.</li>
              <li>
                Mengungkap informasi kepada pemerintah atau pihak yang berwenang untuk urusan yang berkaitan dengan
                hukum yang berlaku.
              </li>
              <li>
                Untuk evaluasi, pengembangan, analisis data, pemecahan masalah, survei, dan peningkatan pelayanan web
                ataupun aplikasi Rasylva.id.
              </li>
            </ul>
          </li>
          <li>
            PENYIMPANAN INFORMASI<br />
            Kami berkomitmen menjaga keamanan data yang telah kami kumpulkan dari pengguna. Beberapa langkah yang kami
            lakukan adalah sebagai berikut:
            <ul class="list-content browser-default disc">
              <li>Pengarsipan secara aman dan terkunci untuk semua berkas.</li>
              <li>Penggunaan enkripsi basis data.</li>
              <li>Proses otentikasi yang ketat untuk dapat mengakses sistem.</li>
            </ul>
          </li>
          <li>
            KEBIJAKAN PRIVASI PIHAK KETIGA<br />
            Rasylva.id tidak akan membagikan data pengunjung atau pengguna ke sembarang pihak. Jika terdapat link ke
            pihak ketiga di situs web kami, belum tentu kami akan membagikan data. Kebijakan Privasi Rasylva.id tidak
            berlaku untuk situs web lain. Karena itu, kami menyarankan Anda untuk membaca dengan seksama masing-masing
            Kebijakan Privasi dari pihak ketiga untuk informasi yang lebih rinci.
          </li>
          <li>
            INFORMASI ANAK<br />
            Salah satu prioritas kami adalah membantu perlindungan untuk anak-anak saat menggunakan internet. Kami
            mendorong orang tua dan wali untuk mengamati, berpartisipasi, memantau, dan membimbing aktivitas online
            mereka. Rasylva.id tidak dengan sengaja mengumpulkan informasi identifikasi pribadi apa pun dari anak-anak
            di bawah umur. Jika menurut Anda anak Anda memberikan informasi semacam ini di situs web kami, kami sangat
            menganjurkan Anda untuk segera menghubungi kami dan kami akan melakukan upaya terbaik kami untuk segera
            hapus informasi tersebut dari catatan kami.
          </li>
          <li>
            KEBIJAKAN LAINNYA<br />
            Rasylva.id berhak memperbarui kebijakan privasi sewaktu-waktu sesuai kondisi dan kebutuhan.
          </li>
          <li>
            PERSETUJUAN<br />
            Dengan menggunakan layanan kami, Anda dianggap telah menyetujui Kebijakan Privasi ini.
          </li>
        </ol>
      </div>
      <div class="container">
        <p><br />Rasylva.id<br />Copyright &copy; 2019-{{ currentYear }} All Rights Reserved.</p>
      </div>
    </main>
    <PageFooter />
  </div>
</template>

<script>
// htmleditor.io
import PageFooter from '~/components/page-footer';
import PageHeader from '~/components/page-header';
import datetimeMixin from '~/mixins/datetime';

export default {
  components: {
    PageFooter,
    PageHeader,
  },
  mixins: [datetimeMixin],
};
</script>

<style lang="scss" scoped>
.list-content {
  margin-top: 4px;
  padding: 0 0px 0 24px;
  text-align: justify;
  .disc {
    list-style-type: disc;
  }
  li {
    margin-bottom: 8px;
  }
}
</style>
